/* Black Colt offer countdowns. Any element with data-bc-end="<unix seconds>" becomes "Ends in 2d 04:12:09". Works in the cart drawer too. */
(function () {
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var now = Math.floor(Date.now() / 1000);
    document.querySelectorAll('[data-bc-end]').forEach(function (el) {
      var left = parseInt(el.getAttribute('data-bc-end'), 10) - now;
      if (isNaN(left)) return;
      if (left <= 0) {
        el.textContent = '';
        var host = el.closest('[data-bc-line]');
        if (host) host.style.display = 'none';
        return;
      }
      var d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600), m = Math.floor(left % 3600 / 60), s = left % 60;
      el.textContent = 'Ends in ' + (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
    });
  }
  tick();
  setInterval(tick, 1000);
})();
